/* eslint no-unused-vars: ["error", { "ignoreRestSiblings": true }] */
import PropTypes from 'prop-types';

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import cx from 'classnames';
import { requestSurfaceTypesList } from 'actionCreators';
import { getSurfaceTypeList } from '../../../../reducers';
import ReactSelect from 'components/StyledSelect/react_select';
import { generateSource } from '../../../../utils';
import reactSelectStyles from 'components/ReactSelect/styles';
import { MILLWORK_SURFACES } from 'config/constants';

class SurfaceTypeSelect extends Component {
  componentDidMount() {
    if (!this.props.loaded) {
      this.props.requestSurfaceTypesList();
    }
  }

  render() {
    const { className, loaded, ...props } = this.props;
    return (
      <ReactSelect
        multi
        resetValue={[]}
        name="surface_type"
        className={cx(reactSelectStyles, className)}
        label="Surface Type"
        {...props}
      />
    );
  }
}

SurfaceTypeSelect.propTypes = {
  options: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.number,
  })),
  value: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.string),
    PropTypes.number,
    PropTypes.arrayOf(PropTypes.number),
  ]),
  className: PropTypes.string,
  loaded: PropTypes.bool.isRequired,
  requestSurfaceTypesList: PropTypes.func.isRequired,
  vendor: PropTypes.string,
};

const getVendorProp = (_, props) => props.vendor;
const getValueProp = (_, props) => props.value;

// No vendor passed (e.g. report/schedule/phase-list filters) means unfiltered, unchanged
// behavior. When a vendor is passed, IFI sees only the millwork surface types and every
// other vendor sees the rest. The currently selected value is always kept in the list even
// if it wouldn't otherwise pass the filter, so a pre-existing/legacy mismatch never renders
// as a blank, data-loss-looking dropdown.
const getSurfaceTypeOptions = createSelector(
  getSurfaceTypeList,
  getVendorProp,
  getValueProp,
  (types, vendor, currentValue) => {
    if (!vendor) return generateSource(types);
    const isIfi = vendor === 'IFI';
    let filtered = types.filter(type => MILLWORK_SURFACES.includes(type.id) === isIfi);
    if (currentValue && !filtered.some(type => type.id === currentValue)) {
      const current = types.find(type => type.id === currentValue);
      if (current) filtered = filtered.concat(current);
    }
    return generateSource(filtered);
  },
);

export default connect(
  (state, ownProps) => (
    { loaded: state.surfaceTypes.loaded, options: getSurfaceTypeOptions(state, ownProps) }
  ),
  { requestSurfaceTypesList },
)(SurfaceTypeSelect);



// WEBPACK FOOTER //
// ./client/app/shared/components/formElements/SurfaceTypeSelect/index.jsx